import { useSelector } from 'react-redux';
import { getSellingIdentifiers } from '../../selector';
import { IStore } from 'store/interface';

export const useSellingIdentifiers = () => ({
  identifiers: useSelector<IStore, string[]>(getSellingIdentifiers),
});
